import { render, staticRenderFns } from "./AreasProtegidasComSojaVegaParaguai.vue?vue&type=template&id=71f3d3fc&lang=pug"
import script from "./AreasProtegidasComSojaVegaParaguai.vue?vue&type=script&lang=js"
export * from "./AreasProtegidasComSojaVegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports